import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@jira/software__devops-fedramp-utils/src/isDevopsFeatureDisabledInFedRamp.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { componentWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { horizontalNavJiraResource } from '@jira/navigation-apps__resources/src/controllers/horizontal-navigation/horizontal-nav-jira/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { softwareCodeRoute } from '@jira/router-routes__next-gen-routes/src/softwareCodeRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayoutCode } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	CodePageNextGen,
	LazyCode,
	softwareCodeNextGenPageEntrypoint,
} from './ui/software/code/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const getHorizontalNavResource = () =>
	fg('entrypoint_migration_for_software_code') ? [] : [horizontalNavJiraResource];

export const softwareCodeRouteEntry: Route = createEntry(softwareCodeRoute, () => ({
	group: 'software',

	// eslint-disable-next-line no-restricted-syntax
	component: componentWithCondition(
		isDevopsFeatureDisabledInFedRamp,
		ErrorPagesNotFound,
		CodePageNextGen,
	),

	layout: softwareProjectLayoutCode,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		...getHorizontalNavResource(),
		// end of resources expanded from getNavigationSidebarProjectResource
	],

	forPaint: [LazyAtlassianNavigation, LazyCode],

	entryPoint: () => {
		if (fg('entrypoint_migration_for_software_code')) {
			return isDevopsFeatureDisabledInFedRamp()
				? notFoundPageEntrypoint
				: softwareCodeNextGenPageEntrypoint;
		}
		return undefined;
	},

	ufoName: 'next-gen-code',
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
